import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=b59ffe02"
import script from "./UserUpdate.vue?vue&type=script&lang=js"
export * from "./UserUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserUpdate.vue?vue&type=style&index=0&id=b59ffe02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports